import { Pipe, PipeTransform } from '@angular/core';
import { Subject } from 'rxjs/Subject'; 

/**
 * 
 * Pipe dedicado obtener costo total de los conceptos en un servicio
 */

@Pipe({
    name: 'sumarCosto' // nombre del pipe en las directivas
})

export class SumarCostoPipe implements PipeTransform{


    // Métdodo a implementar siempre
    transform(objeto:any,repeticionesServicio?:any):any{

	    var costoConcepto = 0
	    var resultado = new Subject();
	    resultado.next(costoConcepto)
	    if (objeto != undefined){
	    	if(typeof objeto == 'object'){
		    	for (var i in objeto) {
			     	 costoConcepto += objeto[i].precio;
						}
				if(repeticionesServicio){
					return costoConcepto * repeticionesServicio;				
				}else{
					return costoConcepto
				}
	    	}else{
			   objeto.subscribe(
			    function (x) {
			    	costoConcepto = 0;
		    	for (var i in x) {
		     	 costoConcepto += x[i].precio;
		   		 }
		   		 resultado.next(costoConcepto);
			    },
			    function (err) {
			        console.log('Error: ' + err);
			    },
			    function () {
			        console.log('Completed');
			    });	 
			    return resultado;   		
	    	}
		}
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/sumar-costos.pipe.ts